jQuery(document).ready(function ($) {
    $('.grid-cards').each(function () {
        const $section = $(this);
        const $toggle = $section.find('.view-more-toggle');
        const $hiddenCards = $section.find('.grid-card.is-hidden');

        if (!$toggle.length || !$hiddenCards.length) return;

        $toggle.on('click', function () {
            $hiddenCards.removeClass('is-hidden');
            $toggle.closest('.view-more-wrapper').hide();
        });
    });
});
